exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".results[data-v-f129abde] {\n  width: 100%;\n  max-height: 400px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  --bg-opacity: 1;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n  margin-top: 0.25rem;\n  border-radius: 0.25rem;\n  border-width: 1px;\n  --border-opacity: 1;\n  border-color: #cbd5e0;\n  border-color: rgba(203, 213, 224, var(--border-opacity));\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --text-opacity: 1;\n  color: #1a202c;\n  color: rgba(26, 32, 44, var(--text-opacity));\n}", ""]);

// exports
